import { render } from "./Scroll.vue?vue&type=template&id=c783d79a&scoped=true&ts=true"
import script from "./Scroll.vue?vue&type=script&lang=ts"
export * from "./Scroll.vue?vue&type=script&lang=ts"

import "./Scroll.vue?vue&type=style&index=0&id=c783d79a&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c783d79a"]])

export default __exports__